import { render, staticRenderFns } from "./TariffPremDetail.vue?vue&type=template&id=a2d9fc4a&"
import script from "./TariffPremDetail.vue?vue&type=script&lang=js&"
export * from "./TariffPremDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports